import { Box, Typography } from "@mui/material";
import InboxIcon from "@mui/icons-material/Inbox";

const EmptyState = ({ message, action, icon }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      py: 6,
      color: "text.secondary",
    }}
  >
    <Box
      sx={{
        mb: 2,
        opacity: 0.4,
        "& .MuiSvgIcon-root": { fontSize: icon ? 64 : 48 },
      }}
    >
      {icon || <InboxIcon />}
    </Box>
    <Typography variant="body1" sx={{ opacity: 0.6 }}>
      {message}
    </Typography>
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
);

export default EmptyState;
